import { useAppQuery } from '@/hooks/useAppQuery';
import { IJobItem } from '@/interfaces/Job';
import { BestLibraryJobMatchResponse as SinglePickResponse } from '@/views/job-benchmarking/hooks/useGetBestLibraryJobMatch';

export interface BestLibraryJobMatchByTextResponse extends SinglePickResponse {
  candidates?: IJobItem[];
}

interface Props {
  text: string;
  enabled?: boolean;
}

export const useGetBestLibraryJobMatchByText = ({ text, enabled }: Props) => {
  const trimmed = text.trim();
  const { data, isLoading, isFetching, error } = useAppQuery<BestLibraryJobMatchByTextResponse>(
    '/StandardLibrary/jobs/best-match',
    {
      config: { params: { text: trimmed } },
      placeholderData: undefined,
      enabled: trimmed.length > 0 && (enabled ?? true),
    }
  );

  return { match: data, isLoading, isFetching, error };
};
